$soupmail.helpers.filter = {

    $filters: {

        _items : {},
        fadeOutWarningTimer : '',
        buttonLabelLength : 36,

        init : function() {

            console.log('init FilterStartup()');

            // reset the filters to nothing
            $soupmail.helpers.filter.$filters._items = {};

            // build the $soupmail.helpers.filter.$filters._items variable for the first time
            jQuery('#search-options li a[rel]').each(function() {

                var $itemProps = jQuery.parseJSON(jQuery(this).attr('rel').replace(/'/gi, '"'));
                $itemProps.label = jQuery(this).html();
                $itemProps.selected = false;
                $itemProps.click = function(event) {
                    event.stopPropagation();
                    $soupmail.helpers.filter.$filters.add(jQuery(this).attr('id'), 'from:init filter startup');
                };
                if (jQuery(this).parent().parent().parent().is('li')) {
                    var $parentItemProps = jQuery.parseJSON(jQuery(this).parent().parent().parent().children('a').attr('rel').replace(/'/gi, '"'));
                    $itemProps.parent = $parentItemProps.id;
                } else {
                    $itemProps.parent = '';
                }
                $soupmail.helpers.filter.$filters._items[$itemProps.id] = $itemProps;
                jQuery(this).parent().attr('id', 'item_' + $itemProps.id);

            });

            // add some special override cases to the $soupmail.helpers.filter.$filters._items
            $soupmail.helpers.filter.$filters._items['search_emails_all'].selected = true;
            $soupmail.helpers.filter.$filters._items['search_emails_all'].click = function(event) {
                $controllers.main.removeAllFilters();
            };
            $soupmail.helpers.filter.$filters._items['search_folder_name'].click = function(event) {
                event.stopPropagation();
            };

            jQuery("#searchbox-typing-cancel").click(function(event) {
                event.preventDefault();
                jQuery("#mod-search-searchword").val("");
                $ultrasearch.methods.ultraSearch(jQuery("#mod-search-searchword"));
                jQuery("#mod-search-searchword").val("Refine Search...");
            });

            jQuery("input.filter_subitems").click(function(event) {
                $soupmail.helpers.filter.temporarilyPreventHeaderClicks();
                jQuery(this).val("");
            });

        },

        add : function($id, $callingFunction, $val, $forceSelectedState, $rebuildEmailsList) {

            // first remove any "Specific Email" filter
            $soupmail.helpers.filter.$filters.specificEmailFilter = '';

            $id = $soupmail.string.dashesToUnderscores($id);

            if ($soupmail.helpers.filter.$filters._items[$id] == null) {
                console.error('Soup Mail Error: cannot filter by "'+$id+'"');
                return false;
            }

            // deselect All Emails, and then toggle the selection of the current item
            if (($forceSelectedState == true) || ($forceSelectedState == false)) {
                $soupmail.helpers.filter.$filters._items[$id].selected = $forceSelectedState;
            } else {
                $soupmail.helpers.filter.$filters._items[$id].selected = !$soupmail.helpers.filter.$filters._items[$id].selected;
            }
            if ($val) {
                $soupmail.helpers.filter.$filters._items[$id].val = $val;
            }

            // if we've unticked a checkbox that is a parent item, then untick all of the child items
            if (($soupmail.helpers.filter.$filters._items[$id].type == 'parent-checkbox') && !$soupmail.helpers.filter.$filters._items[$id].selected) {
                jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                    if ($soupmail.helpers.filter.$filters._items[this.id].parent == $id) {
                        $soupmail.helpers.filter.$filters._items[this.id].selected = false;
                    }
                });
            }

            // if we have clicked on a radio button, deselect all other radio buttons with the same name
            if ($soupmail.helpers.filter.$filters._items[$id].type == 'radio') {
                jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                    if (($soupmail.helpers.filter.$filters._items[this.id].name == $soupmail.helpers.filter.$filters._items[$id].name) && ($soupmail.helpers.filter.$filters._items[this.id].id != $id)) {
                        $soupmail.helpers.filter.$filters._items[this.id].selected = false;
                    }
                });
            }

            // if we have clicked on a filter by date radio button, deselect the datepickers
            if (($soupmail.helpers.filter.$filters._items[$id].name == 'emails_daterange') && $soupmail.helpers.filter.$filters._items[$id].selected) {
                $soupmail.helpers.filter.$filters._items['search_emails_datefrom'].selected = false;
                $soupmail.helpers.filter.$filters._items['search_emails_dateto'].selected = false;
            }

            // if we have clicked on a datepicker, deselect the filter by date radio buttons
            if (($soupmail.helpers.filter.$filters._items[$id].type == 'datepicker') && $soupmail.helpers.filter.$filters._items[$id].selected) {
                if ($soupmail.helpers.filter.$filters._items[$id].val == '') {
                    $soupmail.helpers.filter.$filters._items[$id].selected = false;
                    jQuery('#'+$soupmail.helpers.filter.$filters._items[$id].e1).focus();
                } else {
                    jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                        if ($soupmail.helpers.filter.$filters._items[this.id].name == 'emails_daterange') {
                            $soupmail.helpers.filter.$filters._items[this.id].selected = false;
                        }
                    });
                }
            }

            // if we have clicked on a datepicker, store the current altField value in .val2
            if ($soupmail.helpers.filter.$filters._items[$id].type == 'datepicker') {
                $soupmail.helpers.filter.$filters._items[$id].valAlternate = jQuery('#'+$soupmail.helpers.filter.$filters._items[$id].e1+'_valuefield').val();
            }

            // refresh everything on screen, rebuild it all again
            $soupmail.helpers.filter.rebuildFilterBy();
            $soupmail.helpers.filter.$filters.renderMenu();
            $soupmail.helpers.filter.toggleOtherFiltersIndicator();
            $soupmail.helpers.filter.toggleClearFilterButton();
            if ($soupmail.helpers.filter.anyFiltersEnabled()) {
                jQuery('.soupmail-filter-bar').show();
                jQuery('.search .filterbutton').addClass('active');
                $views.main.resizeLHScolumn();
            }else{
                jQuery('.soupmail-filter-bar').hide();
            }
            if ($rebuildEmailsList !== false) {
                $models.main.currentEmailsListOffset = 0;
                $models.main.getEmailsList({});
            }

        },

        remove : function($id) {

            // untick this selection
            $soupmail.helpers.filter.$filters._items[$id].selected = false;

            // if we've clicked on a checkbox or radio button, and it is a child item, then tick the parent item's checkbox
            if ($soupmail.helpers.filter.$filters._items[$id].parent) {
                var $parentId = $soupmail.helpers.filter.$filters._items[$id].parent;
                var $parentSelected = false;
                jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                    if ((this.parent == $parentId) && $soupmail.helpers.filter.$filters._items[this.id].selected) {
                        $parentSelected = true;
                    }
                });
                $soupmail.helpers.filter.$filters._items[$parentId].selected = $parentSelected;
            }

            // rebuild and then remove any necessary filter by button
            $soupmail.helpers.filter.$filters.renderMenu();
            if (jQuery('#filterby_' + $id).size() >= 1) {
                if (jQuery('#filterby_' + $id).parent().attr('id') == 'search-filter-list-items') {
                    jQuery('#search-filter-list-indicator').toggleClass('expanded');
                }
                jQuery('#filterby_' + $id).fadeOut(300, function() {
                    jQuery('#filterby_' + $id).remove();
                    rebuildFilterBy();
                    toggleOtherFiltersIndicator();
                    $soupmail.helpers.filter.toggleClearFilterButton();
                    if (!$soupmail.helpers.filter.anyFiltersEnabled()) {
                        //				jQuery('.search .button span').text('All emails');
                        jQuery('.search .filterbutton').removeClass('active').removeClass('phone-active');
                    }
                });
            }

            $models.main.currentEmailsListOffset = 0;
            $models.main.getEmailsList({});
        },

        renderMenu : function($params) {

            $views.main.renderCachedContactsToFilterMenu($params);
            $views.main.renderCachedFoldersToFilterMenu($params);
            $views.main.renderCachedTagsToFilterMenu($params);

            if ($soupmail.helpers.filter.anyFiltersEnabled()) {
                $soupmail.helpers.filter.$filters._items['search_emails_all'].selected = false;
            }

            // temporarily deselect any parent checkboxes
            jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                if ($soupmail.helpers.filter.$filters._items[this.id].parent) {
                    var $parentId = $soupmail.helpers.filter.$filters._items[this.id].parent;
                    $soupmail.helpers.filter.$filters._items[$parentId].selected = false;
                }
            });

            // for any checkboxes or radio buttons, if it is a child item and is ticked, then tick the parent item's checkbox
            jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                if ($soupmail.helpers.filter.$filters._items[this.id].parent && $soupmail.helpers.filter.$filters._items[this.id].selected) {
                    var $parentId = $soupmail.helpers.filter.$filters._items[this.id].parent;
                    $soupmail.helpers.filter.$filters._items[$parentId].selected = true;
                }
            });

            jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                if (!this.labelextra) {
                    this.labelextra = '';
                }
                if (this.type == 'checkbox') {
                    jQuery('#search-options #item_' + this.id).html('<div class="checkbox"><input type="checkbox" name="'+this.name+'" id="'+this.id+'" value="'+this.val+'" class="" '+(this.selected ? 'checked="checked"' : '')+' /></div><label for="'+this.id+'">'+this.label + this.labelextra+'</label><div class="clear"></div>');
                }
                if (this.type == 'radio') {
                    jQuery('#search-options #item_' + this.id).html('<div class="checkbox"><input type="radio" name="'+this.name+'" id="'+this.id+'" value="1" class="" '+(this.selected ? 'checked="checked"' : '')+' /></div><label for="'+this.id+'">'+this.label + this.labelextra+'</label><div class="clear"></div>');
                }
                if ((this.type == 'datepicker') && !$config.mobile) {
                    //jQuery('#search-options #item_' + this.id).html('<div class="checkbox"><input type="checkbox" name="'+this.name+'" id="'+this.id+'" value="1" class="" '+(this.selected ? 'checked="checked"' : '')+' /></div><label for="'+this.id+'" style="float:left; width:40px">'+this.label + this.labelextra+'</label><input type="text" title="" name="'+this.e1+'" id="'+this.e1+'" value="'+this.val+'" style="width:74px; font-size:12px; vertical-align:top" onclick="$soupmail.helpers.filter.temporarilyPreventHeaderClicks();" /><input type="hiddens" title="" name="'+this.e1+'_valuefield" id="'+this.e1+'_valuefield" value="'+this.valAlternate+'" /><div class="datepicker"></div> ');
                    //jQuery('#search-options #item_' + this.id).html('<div class="checkbox"><input type="checkbox" name="'+this.name+'" id="'+this.id+'" value="1" class="" '+(this.selected ? 'checked="checked"' : '')+' /></div><label for="'+this.id+'" style="float:left; width:40px">'+this.label + this.labelextra+'</label><input type="text" title="" name="'+this.e1+'" id="'+this.e1+'" value="'+this.val+'" style="width:74px; font-size:12px; vertical-align:top" class="datepicker" onclick="$soupmail.helpers.filter.temporarilyPreventHeaderClicks();" /><input type="hidden" title="" name="'+this.e1+'_valuefield" id="'+this.e1+'_valuefield" value="'+this.valAlternate+'" /> ');
                    jQuery('#search-options #item_' + this.id).html('<div class="checkbox"><input type="checkbox" name="'+this.name+'" id="'+this.id+'" value="1" class="" '+(this.selected ? 'checked="checked"' : '')+' /></div><label for="'+this.id+'" style="float:left; width:40px">'+this.label + this.labelextra+'</label><!--<input type="text" title="" name="'+this.e1+'" id="'+this.e1+'" value="'+this.val+'" style="width:74px; font-size:12px; vertical-align:top" />--><input type="text" title="" name="'+this.e1+'_valuefield" id="'+this.e1+'_valuefield" value="'+this.valAlternate+'" readonly="readonly" /><div id="'+this.e1+'" class="datepicker"></div>');
                } else if (this.type == 'datepicker') {
                    jQuery('#search-options #item_' + this.id).html('<div class="checkbox"><input type="checkbox" name="'+this.name+'" id="'+this.id+'" value="1" class="" '+(this.selected ? 'checked="checked"' : '')+' /></div><label for="'+this.id+'">'+this.label + this.labelextra+'</label><input type="date" title="'+this.id+'" name="'+this.e1+'" id="'+this.e1+'" value="'+this.val+'" style="width:134px; font-size:13px; vertical-align:top" class="native-datepicker" /><input type="hidden" title="" name="'+this.e1+'_valuefield" id="'+this.e1+'_valuefield" value="'+this.valAlternate+'" />');
                }
                if (this.type == 'parent-checkbox') {
                    jQuery('#search-options #item_' + this.id).removeClass('parent').addClass('parent');
                    jQuery('#search-options #item_' + this.id + ' a[href="#"]').remove();
                    jQuery('#search-options #item_' + this.id + ' .parent-row').remove();
                    jQuery('#search-options #item_' + this.id).prepend('<div class="parent-row"><div class="checkbox"><input type="checkbox" id="'+this.id+'" value="'+this.val+'" class="" '+(this.selected ? 'checked="checked"' : 'disabled="disabled"')+' /></div><label for="'+this.id+'">'+this.label + this.labelextra+'</label><div class="clear"></div></div>');
                }
                if (this.type == 'autocomplete') {
                    if (this.val == '') { this.val = this.label; }
                    jQuery('#search-options #item_' + this.id).html('<input type="text" name="'+this.name+'" id="'+this.id+'" class="filter_subitems" value="'+this.val+'" onkeyup="'+this.e1+'" onkeydown="if (this.value==\''+this.label+'\') this.value=\'\';" onclick="if (this.value==\''+this.label+'\') this.value=\'\';" onblur="if (this.value==\'\') this.value=\''+this.val+'\';" style="vertical-align:middle; width:155px" />');
                }
                if (typeof(this.click) == 'function') {
                    jQuery('#search-options #' + this.id).click(this.click);
                }
            });
            jQuery('.datepicker').each(function() {
                var $valueFieldSelector = '#' + jQuery(this).attr('id') + '_valuefield';
                if (jQuery(this).attr('id') == 'datefrom') {
                    var $options = {
                        defaultDate: ($soupmail.helpers.filter.$filters._items['search_emails_datefrom'].val ? $soupmail.helpers.filter.$filters._items['search_emails_datefrom'].val : '-1w'),
                        minDate: new Date(1990, 1 - 1, 1),
                        maxDate: ($soupmail.helpers.filter.$filters._items['search_emails_dateto'].val ? $soupmail.helpers.filter.$filters._items['search_emails_dateto'].val : "+1d"),
                        changeMonth: true,
                        changeYear: true,
                        dateFormat: 'dd/mm/yy',
                        altField: $valueFieldSelector,
                        altFormat: 'D, dd M yy',
                        onClose: function(selectedDate) {

                        },
                        onSelect : function(selectedDate, obj) {
                            //jQuery("#dateto").datepicker( "option", "minDate", selectedDate );
                            //$id = jQuery('#datefrom').parent().attr("id").replace("item_", "");
                            $soupmail.helpers.filter.$filters.add('search_emails_datefrom', 'datePicker change', jQuery('#datefrom').val(), true);
                        }
                    };
                } else {
                    var $options = {
                        defaultDate: ($soupmail.helpers.filter.$filters._items['search_emails_dateto'].val ? $soupmail.helpers.filter.$filters._items['search_emails_dateto'].val : ''),
                        minDate: ($soupmail.helpers.filter.$filters._items['search_emails_datefrom'].val ? $soupmail.helpers.filter.$filters._items['search_emails_datefrom'].val : new Date(1990, 1 - 1, 1)),
                        maxDate: "+1d",
                        changeMonth: true,
                        changeYear: true,
                        dateFormat: 'dd/mm/yy',
                        altField: $valueFieldSelector,
                        altFormat: 'D, dd M yy',
                        onClose: function(selectedDate) {

                        },
                        onSelect : function(selectedDate, obj) {
                            //jQuery("#datefrom").datepicker( "option", "maxDate", selectedDate );
                            //$id = jQuery('#dateto').parent().attr("id").replace("item_", "");
                            $soupmail.helpers.filter.$filters.add('search_emails_dateto', 'datePicker change', jQuery('#dateto').val(), true);
                        }
                    };
                }
                jQuery(this).datepicker($options);
            });
            jQuery('.native-datepicker').blur(function() { $soupmail.helpers.filter.$filters.add(jQuery(this).attr('title'), 'from:rebuild Filter Dropdown', jQuery(this).val()); });
            jQuery("#search-options label").click(function(event) { event.stopPropagation(); });
            jQuery("#item_search_emails_folder > div > label").click(function(event) {
                jQuery("#search_folder_name").focus().setCursorToTextEnd();
            }).hover(function() {
                jQuery("#search_folder_name").focus().setCursorToTextEnd();
            });
            if ($soupmail.helpers.filter.anyFiltersEnabled()) {
                jQuery('.soupmail-filter-bar').show();
            }

        }
    },

    anyFiltersEnabled: function () {
        var $anyFiltersEnabled = false;
        if ($soupmail.helpers.filter.$filters.specificEmailFilter) { return true; }
        jQuery.each($soupmail.helpers.filter.$filters._items, function() {
            if (this.selected && (this.id != 'search_emails_all')) {
                $anyFiltersEnabled = true;
            }
        });
        return $anyFiltersEnabled;
    },

    rebuildFilterByBar: function () {
        if (!jQuery('body').hasClass('phone-mode')) {
            console.log('rebuild FilterByBar()');
            jQuery('.filterby').remove();
            jQuery.each($soupmail.helpers.filter.$filters._items, function() {
                if (this.selected && (this.type != 'parent-checkbox') && (this.type != 'autocomplete') && (this.id != 'search_emails_all')) {
                    $fullLabel = ( ((this.e1 == 'addprefix') && this.parent) ? $soupmail.helpers.filter.$filters._items[this.parent].label+': ' : '' ) + this.label + ((this.type == 'datepicker') ? ' '+this.val : '');
                    $truncatedLabel = (($fullLabel.length > $soupmail.helpers.filter.$filters.buttonLabelLength) ? $fullLabel.substr(0, $soupmail.helpers.filter.$filters.buttonLabelLength)+'...' : '');
                    jQuery('#search-filter-list-items').append('<div id="filterby_'+this.id+'" title="'+($truncatedLabel ? $fullLabel : '')+'" class="filterby filterby_'+this.id+'" onclick="$soupmail.helpers.filter.$filters.remove(\''+this.id+'\')"><div class="icon-filter icon-filter-'+(this.icon ? this.icon : 'sample')+'">'+ ($truncatedLabel ? $truncatedLabel : $fullLabel) + '</div></div>');
                }
            });
            if ($soupmail.helpers.filter.$filters.specificEmailFilter) {
                var $truncatedLabel = (($soupmail.helpers.filter.$filters.specificEmailFilter.subject.length > $soupmail.helpers.filter.$filters.buttonLabelLength) ? $soupmail.helpers.filter.$filters.specificEmailFilter.subject.substr(0, $soupmail.helpers.filter.$filters.buttonLabelLength)+'...' : $soupmail.helpers.filter.$filters.specificEmailFilter.subject);
                jQuery('#search-filter-list-items').append('<div title="'+$truncatedLabel+'" class="filterby filterby_specific_email_'+$soupmail.helpers.filter.$filters.specificEmailFilter.id+'" onclick="$soupmail.helpers.filter.$filters.specificEmailFilter = \'\'; rebuildFilterBy(); toggleOtherFiltersIndicator(); toggleClearFilterButton(); $models.main.currentEmailsListOffset = 0; $models.main.getEmailsList({}); return false"><div class="icon-filter icon-filter-sample icon-filter-email">'+$truncatedLabel+'</div></div>');
            }
            if ($soupmail.helpers.filter.anyFiltersEnabled()) {
                jQuery('.soupmail-filter-bar').show();
            } else {
                jQuery('.soupmail-filter-bar').hide();
            }
            $views.main.resizeLHScolumn();
        }
    },

    rebuildFilterBy: function () {
        if (!$soupmail.helpers.filter.anyFiltersEnabled()) {
            $controllers.main.removeAllFilters();
        } else {
            $soupmail.helpers.filter.rebuildFilterByBar();
        }
    },

    toggleClearFilterButton: function () {
        if ($soupmail.helpers.filter.anyFiltersEnabled()) {
            jQuery('#search-filter-list-clearer').show();
        } else {
            jQuery('#search-filter-list-clearer').hide();
        }
    },

    toggleOtherFiltersIndicator: function () {

        if (!jQuery('body').hasClass('phone-mode')) {

            // first, calculate how many .filterby objects we have displaying on screen
            var $availableFilterListWidth = jQuery('.soupmail-filter-bar').width() - jQuery('#search-filter-list-clearer').outerWidth(true) - jQuery('#search-filter-list-indicator').outerWidth(true) - 10;
            var $actualFilterListWidth = 0;
            var $numberOfFilterBysDisplayed = 0;
            var $continueIteratingLoop = true;
            jQuery('#search-filter-list-items .filterby').each(function() {
                if ($continueIteratingLoop) {
                    $actualFilterListWidth += jQuery(this).outerWidth(true);
                    if ($actualFilterListWidth >= $availableFilterListWidth) {
                        $continueIteratingLoop = false;
                    } else {
                        $numberOfFilterBysDisplayed++;
                    }
                }
            });

            jQuery('.soupmail-filter-bar .filterby').show();

            // now, if the number of .filterby objects available exceeds the number being displayed, then lets show the Filters Indicator, otherwise hide it
            if (($numberOfFilterBysDisplayed > 0) && ($numberOfFilterBysDisplayed < jQuery('#search-filter-list-items .filterby').size())) {
                $numberOfOtherFiltersAvailable = jQuery('#search-filter-list-items .filterby').size() - $numberOfFilterBysDisplayed;
                jQuery('#search-filter-list-indicator').show().html('<div class="popout"></div>+ '+$numberOfOtherFiltersAvailable+' more');
                jQuery('#search-filter-list-indicator').removeClass('expanded');
                jQuery('.soupmail-filter-bar .filterby:eq('+($numberOfFilterBysDisplayed-1)+')').after(jQuery('#search-filter-list-indicator'));	// this moves the filters indicator to be in the correct position (otherwise it would be last, where it would be cut off and we wouldn't see it)
                jQuery('#search-filter-list-indicator .popout').html('');
                jQuery('.soupmail-filter-bar .filterby:gt('+($numberOfFilterBysDisplayed-1)+')').hide();
                jQuery('.soupmail-filter-bar .filterby:gt('+($numberOfFilterBysDisplayed-1)+')').each(function() {
                    //jQuery('#search-filter-list-indicator .popout').append('<div id="'+jQuery(this).attr('id')+'" title="Click to remove from filter" class="" onclick="$controllers.all.preventHeaderClickHandler = true; jQuery(this).fadeOut(\'slow\', function() { $preventHeaderClickHandler = false; '+jQuery(this).attr('onclick')+' });">'+jQuery(this).html()+'</div>');
                    jQuery('#search-filter-list-indicator .popout').append('<div id="'+jQuery(this).attr('id')+'" title="Click to remove from filter" class="subfilter" clickhandler="'+jQuery(this).attr('onclick')+'">'+jQuery(this).html()+'</div>');
                    jQuery('#'+jQuery(this).attr('id')).click(function(event) {
                        event.stopPropagation();
                        jQuery(this).fadeOut(300, function() {
                            eval(jQuery(this).attr('clickhandler'));
                        });
                    });
                });
            } else {
                jQuery('#search-filter-list-indicator').hide();
            }

        }

    },

    searchFolderChange: function ($obj) {
        var $thisId = jQuery($obj).attr('id');
        $soupmail.helpers.filter.$filters._items[$thisId].val = jQuery($obj).val();
        jQuery.each($soupmail.helpers.filter.$filters._items, function() {
            if ((this.parent == 'search_emails_folder') && (this.type == 'checkbox') && (this.label.toLowerCase().indexOf(jQuery("#search_folder_name").val().toLowerCase()) >= 0)) {
                jQuery('#item_search_emails_folder #item_'+this.id).show();
            } else if ((this.parent == 'search_emails_folder') && (this.type == 'checkbox')) {
                jQuery('#item_search_emails_folder #item_'+this.id).hide();
            }
        });
    },

    temporarilyPreventHeaderClicks: function() {
        $controllers.all.preventHeaderClickHandler = true;
        setTimeout(function() {
            $controllers.all.preventHeaderClickHandler = false;
        }, 500);
    }

}



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.control.filter.js